import { render, staticRenderFns } from "./RunnitsOwnerSelectionPicker.vue?vue&type=template&id=5a0b5b9e"
import script from "./RunnitsOwnerSelectionPicker.vue?vue&type=script&lang=ts"
export * from "./RunnitsOwnerSelectionPicker.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports